import React, { useState, useEffect } from "react";
import Gallery from "./Gallery";
import SEOHead from "./SEOHead";
import { api } from "../services/api";

function GallerySection() {
  const [mediaItems, setMediaItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchMediaItems = async () => {
      try {
        const data = await api.getGallery();
        setMediaItems(Array.isArray(data) ? data : []);
      } catch (error) {
        console.error("Failed to load gallery items:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchMediaItems();
  }, []);

  if (loading) {
    return (
      <div className="text-center py-5">
        <SEOHead title="Loading Surgical Gallery | Dr. Sunil Apsingi" noindex={true} />
        <div className="spinner-border text-teal" role="status">
          <span className="visually-hidden">Loading gallery...</span>
        </div>
        <p className="text-muted mt-2 small">Loading surgical gallery...</p>
      </div>
    );
  }

  return (
    <section className="gallery-page-section section-padding">
      <SEOHead
        title="Clinical & Surgical Gallery | Dr. Sunil Apsingi Hyderabad"
        description="Visual documentation, clinical photographs, and operative theater media of joint replacement and arthroscopic procedures by Dr. Sunil Apsingi."
        canonicalPath="/gallery"
        breadcrumbs={[
          { name: "Home", path: "/" },
          { name: "Gallery", path: "/gallery" },
        ]}
      />
      <div className="container">
        <div className="text-center mb-5">
          <span className="section-header-pill">
            <i className="fa-solid fa-photo-film me-1"></i> Visual Media
          </span>
          <h1 className="section-title-large">Surgical & Clinical Gallery</h1>
          <p className="section-subtitle-muted">
            Clinical photos, operating theater media, and instructional surgery explanations from Dr. Sunil Apsingi.
          </p>
        </div>

        <Gallery mediaItems={mediaItems} />
      </div>
    </section>
  );
}

export default GallerySection;
